interface DashboardDividendIncomeInput {
  totalDividendsReceived: number;
  projectedForwardDividend: number;
  annualExpenses: number;
  formatCurrency: (value: number) => string;
}

export interface DashboardDividendIncomeKpi {
  value: string;
  subValue: string;
  secondaryValue: string;
  tooltip: string;
}

export const buildDashboardDividendIncomeKpi = ({
  totalDividendsReceived,
  projectedForwardDividend,
  annualExpenses,
  formatCurrency,
}: DashboardDividendIncomeInput): DashboardDividendIncomeKpi => {
  const received = Number.isFinite(totalDividendsReceived)
    ? Math.max(0, totalDividendsReceived)
    : 0;
  const projectedForward = Number.isFinite(projectedForwardDividend)
    ? Math.max(0, projectedForwardDividend)
    : 0;
  const secondaryValue = (() => {
    if (projectedForward > 0) {
      return "Forward schedule from declared market events";
    }

    if (projectedForward === 0 && received > 0) {
      return "Forward schedule not confirmed yet";
    }

    return "No imported or confirmed dividends yet";
  })();

  return {
    value: `${formatCurrency(received)} received`,
    subValue: `${formatCurrency(projectedForward)} confirmed next 12m`,
    secondaryValue,
    tooltip:
      "Actual imported dividends received are shown first. Confirmed next-12-month income only uses declared market events.",
  };
};
